export const GOUSTO_WORTH = {
  altText: 'Customer finishing up a creamy Sweet Potato And Black Bean tomato Stew',
  ctaText: 'Get your first box with 50% off now',
}
